<div class="app-content content container-fluid left">
    <div class="content-wrapper">

        <div class="content-body">
            <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12" *ngFor="let item of items">

                    <div class="card box-shadow-2 text-center">
                        <div class="card-body">
                            <div class="card-block">
                                <h4 *ngIf="item.price" class="card-subtitle">{{item['item_name_fa']}}</h4>
                            </div>

                            <img *ngIf="item.image_url" class="img-fluid fit" [src]="item.image_url" alt="{{item.item_name}}"
                                style="max-height: 220px;">
                                <div>
                                    <a class="btn btn-outline-success teal add-invoice d-inline-block fit"
                                        (click)="priceChoosed(item)">{{item.price ? (item.price | money: translator.getDefaultLang()) : ('NO_NEED' | translate)  }}
                                        <i class="icon-shopping-basket"></i>
                                    </a>
                                </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>